import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { CompleteApplePayProvisioningRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { CompleteApplePayProvisioningResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const completeApplePayProvisioning = (
  request: CompleteApplePayProvisioningRequest,
  options?: CashRequestOptions
) =>
  post<CompleteApplePayProvisioningRequest, CompleteApplePayProvisioningResponse>(
    '/2.0/cash/complete-apple-pay-provisioning',
    request,
    { ...options, rejectOnError: true }
  )
